import {PermissionCollection} from "../../../collections/Permissions";

export class ControlPermissionCollection extends PermissionCollection {
    canCreateNewControlGroup = this.generatePermissionFunction('app', 'ctrlg', 'create');
    canViewControlGroup = this.generatePermissionFunction('ctrlg', null, 'view');
    canModifyControlGroup = this.generatePermissionFunction('ctrlg', null, 'modify');
    canDeleteControlGroup = this.generatePermissionFunction('ctrlg', null, 'delete');
}





// WEBPACK FOOTER //
// ./srv/public/js/apps/controls/collections/ControlPermissions.ts